export default __webpack_public_path__ + "static/char-s-14-kr-f74c424d9910d3081b251a4b5d236a9f.webp";